module.exports = __webpack_public_path__ + "img/ENKI_Logo.a1c935d4.webp";